import type { CiaDependencies } from '~/composables/useCia/types';
import type { ConsentProps } from '~/composables/useCia/event/tracking/consent';

type CustomerConsentRequest = {
  locale?: string;
  consents: Array<keyof ConsentProps>;
  email_token?: string;
  email?: string;
  cookie?: string;
  user_id?: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, languageAndCountry } = dependencies;

  return async (emailToken: string = ''): Promise<unknown> => {

    const consents: Array<keyof ConsentProps> = [
      'newsletter',
      'sms',
      'phone',
      'soft_newsletter',
      'soft_phone',
      'soft_sms',
    ];

    const payload: CustomerConsentRequest = {
      locale: languageAndCountry,
      consents,
    };

    if (emailToken) {

      payload.email_token = emailToken;
    
    }

    return fetch('/cia/customer-consent', {
      method: 'POST',
      body: payload,
    });
  
  };

};
